var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5304 20.5303C17.3897 20.671 17.1989 20.75 17 20.75C16.8011 20.75 16.6103 20.671 16.4697 20.5303L11.4697 15.5303C11.2552 15.3158 11.191 14.9932 11.3071 14.713C11.4232 14.4327 11.6967 14.25 12 14.25H16.25V4C16.25 3.58579 16.5858 3.25 17 3.25C17.4142 3.25 17.75 3.58579 17.75 4V14.25H22C22.3034 14.25 22.5768 14.4327 22.6929 14.713C22.809 14.9932 22.7449 15.3158 22.5304 15.5303L17.5304 20.5303Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53035 3.46967C7.3897 3.32902 7.19893 3.25 7.00002 3.25C6.80111 3.25 6.61034 3.32902 6.46969 3.46967L1.46969 8.46967C1.25519 8.68417 1.19103 9.00676 1.30711 9.28701C1.4232 9.56727 1.69668 9.75 2.00002 9.75H6.25002V20C6.25002 20.4142 6.58581 20.75 7.00002 20.75C7.41424 20.75 7.75002 20.4142 7.75002 20V9.75H12C12.3034 9.75 12.5768 9.56727 12.6929 9.28701C12.809 9.00676 12.7449 8.68417 12.5304 8.46967L7.53035 3.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.dcb8645cec830a203f21282a9c9223b2.svg";
export { ForwardRef as ReactComponent };